import axios from "../config/axiosInstance";

export const miniGameService = {
  createQuestions: async (question, userId) => {
    return await axios.post(`/games/questions?staffId=${userId}`, question);
  },

  generateQuestions: async () => {
    return await axios.post(`/games/questions/generate`);
  },

  fetchPendingQuestions: async () => {
    return await axios.get(`/games/questions/pending`);
  },

  approveQuestion: async (id, userId) => {
    return await axios.post(`/games/questions/approve/${id}?staffId=${userId}`);
  },

  discardQuestion: async (id) => {
    return await axios.delete(`/games/questions/discard/${id}`);
  },

  fetchGameSettings: async () => {
    return await axios.get(`/games/settings`);
  },

  updateSettings: async (payload) => {
    return await axios.put(`/games/settings`, payload);
  },

  startQuiz: async (userId) => {
    return await axios.get(`/games/quiz/${userId}`);
  },

  submitAnswers: async (sessionId, newAnswers, userId) => {
    return await axios.post(`/games/submit/${sessionId}/${userId}`, newAnswers);
  },
};
